// Trimmed script: adds a data-featured-list attribute (styled via CSS attribute
// selector) to menu items containing an "Essentials" link. Uses a data attribute
// instead of a class because the site's own menu widget (tmenu) overwrites the
// full `class` attribute on hover/activate, which was wiping out a class-based
// flag and causing a visible flicker.

function addMenuClasses() {
    try {
        const menuWrappers = document.querySelectorAll('.tmenu_wrapper');
        if (menuWrappers.length === 0) return false;

        let totalProcessed = 0;
        let totalLisModified = 0;
        const monitoredElements = window.menuClassMonitoredElements || new Set();

        menuWrappers.forEach((wrapper) => {
            try {
                const essentialsLinks = wrapper.querySelectorAll('a[title*="Essentials"]');

                essentialsLinks.forEach((essentialsLink) => {
                    const parentLi = essentialsLink.closest('li');
                    if (parentLi && !parentLi.hasAttribute('data-featured-list')) {
                        parentLi.setAttribute('data-featured-list', 'true');
                        monitoredElements.add(parentLi);
                        totalLisModified++;
                    }
                });

                totalProcessed++;
            } catch (wrapperErr) {
                console.warn('[menu-classes] Skipped a menu wrapper due to error:', wrapperErr);
            }
        });

        window.menuClassMonitoredElements = monitoredElements;
        return totalProcessed > 0;
    } catch (err) {
        console.warn('[menu-classes] addMenuClasses failed:', err);
        return false;
    }
}

function setupContinuousMonitoring() {
    let lastProcessTime = 0;
    const THROTTLE_DELAY = 100;
    let debounceTimer = null;

    function throttledAddMenuClasses() {
        if (debounceTimer) clearTimeout(debounceTimer);
        debounceTimer = setTimeout(() => {
            debounceTimer = null;
            lastProcessTime = Date.now();
            try {
                addMenuClasses();
            } catch (err) {
                console.warn('[menu-classes] reapply failed:', err);
            }
        }, THROTTLE_DELAY);
    }

    const observer = new MutationObserver((mutations) => {
        try {
            let shouldCheck = false;
            const monitored = window.menuClassMonitoredElements;

            mutations.forEach((mutation) => {
                const target = mutation.target;
                const isInMenu =
                    target &&
                    target.nodeType === Node.ELEMENT_NODE &&
                    target.closest('.tmenu_wrapper, .tmenu_submenu') !== null;
                if (!isInMenu) return;

                mutation.addedNodes.forEach((node) => {
                    if (node.nodeType === Node.ELEMENT_NODE) {
                        if (node.querySelector && node.querySelector('a[title*="Essentials"]')) {
                            shouldCheck = true;
                        }
                    }
                });

                // Attribute changes no longer matter for our own flag since
                // tmenu doesn't touch data-* attributes, but keep watching
                // class changes in case tmenu restructures children.
                if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                    if (monitored && monitored.has(target)) {
                        shouldCheck = true;
                    }
                }
            });

            if (shouldCheck) throttledAddMenuClasses();
        } catch (err) {
            console.warn('[menu-classes] observer callback error:', err);
        }
    });

    document.querySelectorAll('.tmenu_wrapper').forEach(wrapper => {
        observer.observe(wrapper, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ['class']
        });
    });

    const documentObserver = new MutationObserver((mutations) => {
        try {
            mutations.forEach((mutation) => {
                mutation.addedNodes.forEach((node) => {
                    if (node.nodeType === Node.ELEMENT_NODE &&
                        (node.classList?.contains('tmenu_wrapper') || node.querySelector?.('.tmenu_wrapper'))) {
                        observer.observe(node, {
                            childList: true,
                            subtree: true,
                            attributes: true,
                            attributeFilter: ['class']
                        });
                    }
                });
            });
        } catch (err) {
            console.warn('[menu-classes] document observer error:', err);
        }
    });

    if (document.body) {
        documentObserver.observe(document.body, { childList: true, subtree: true });
    } else {
        console.warn('[menu-classes] document.body not ready; skipping fallback observer');
    }

    const periodicCheck = setInterval(() => {
        try {
            if (Date.now() - lastProcessTime > 5000) {
                const essentialsLinks = document.querySelectorAll('a[title*="Essentials"]');
                let needsCheck = false;
                essentialsLinks.forEach(essentialsLink => {
                    const parentLi = essentialsLink.closest('li');
                    if (parentLi && !parentLi.hasAttribute('data-featured-list')) {
                        needsCheck = true;
                    }
                });
                if (needsCheck) throttledAddMenuClasses();
            }
        } catch (err) {
            console.warn('[menu-classes] periodic check error:', err);
        }
    }, 5000);

    setTimeout(() => clearInterval(periodicCheck), 300000);

    return { observer, documentObserver, periodicCheck };
}

let initAttempts = 0;
const MAX_INIT_ATTEMPTS = 40;

function initialize() {
    try {
        const menuWrappers = document.querySelectorAll('.tmenu_wrapper');
        if (menuWrappers.length === 0) {
            initAttempts++;
            if (initAttempts >= MAX_INIT_ATTEMPTS) {
                console.warn('[menu-classes] No .tmenu_wrapper found after retries; giving up.');
                return;
            }
            setTimeout(initialize, 500);
            return;
        }

        addMenuClasses();
        setupContinuousMonitoring();
    } catch (err) {
        console.warn('[menu-classes] initialize failed:', err);
    }
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
} else {
    initialize();
}